export default __webpack_public_path__ + "7bbe1c8847f08b1633a0b59bcbe65ce0.woff";